import { createStore } from "vuex";

export default createStore({
  state: {
    // server: "http://127.0.0.1:8000/",
    server: "https://nexusleap.com.sa/NexusLeapBackend/public/",
    token: "",
    user_type: "",
    unread: 0,
    phone: "",
    instagram: "",
    facebook: "",
    linkdin: "",
    skype: "",
    twitter: "",
    loaction_name_ar: "",
    loaction_name_en: "",
    email: "",
    welcome_message_ar: "",
    welcome_message_en: "",
    products: [],
    loading_state: 0,
    stories: 0,
    // Data
    Data: [],
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
